import axios from "axios";

declare const jQuery: any;

export default class Downloads {

    private table: HTMLTableElement

    constructor(table: HTMLTableElement) {
        this.table = table;
        this.init();
        this.init_row_events();
    }

    getVersionLinks() {
        return this.table.querySelectorAll<HTMLLinkElement>('[data-ajax-versions]');
    }

    init() {

        this.getVersionLinks().forEach(link => {

            link.addEventListener('click', e => {
                e.preventDefault();

                const plugin = link.dataset.plugin;
                const subscriptionId = link.dataset.subscription_id;
                const row = link.closest('tr')

                link.insertAdjacentHTML( 'beforeend', '<span class="ajax-loading"></span>' );

                getVersion( plugin, subscriptionId ).then( d => {
                    let rowContainer: HTMLTableElement = document.createElement('table');
                    rowContainer.innerHTML = d.data;

                    row.classList.add( 'versions_loaded' );

                    [ ...rowContainer.querySelectorAll<HTMLTableRowElement>('tr')].reverse().forEach( newRow =>{
                        newRow.classList.add( plugin );
                        newRow.style.display = 'table-row';

                        row.parentElement.insertBefore( newRow, row.nextElementSibling );
                    });

                    row.querySelectorAll<HTMLElement>( '.ajax-loading' ).forEach( el => el.remove() );
                    link.remove();
                    this.init_row_events()
                });

            });


        });
    }

    init_row_events() {
        this.table.querySelectorAll('.download-changelog').forEach(el => {
            jQuery(el).actooltip();
        });
    }

}


const getVersion = (plugin: string, subscriptionId: string) => {
    const data = new FormData();
    data.set('action', 'account_download_versions');
    data.set('plugin', plugin);
    data.set('subscription_id', subscriptionId);
    return axios.post(codepress.ajaxurl, data);
}